import { render } from "./DashboardSearchNoResult.vue?vue&type=template&id=07f208ee&ts=true"
import script from "./DashboardSearchNoResult.vue?vue&type=script&lang=ts"
export * from "./DashboardSearchNoResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__